import React, { useState, useRef, useEffect } from "react";
import {
  SimpleLoading,
  PromotionalFooterPure,
  DialogSystemGLPure,
} from "../../pures";
import "./calligraphic-exercises-report-detail-request.css";
import PlusGreen from "../../../assets/logos/icons/plus_green.png";
import PlusBlue from "../../../assets/logos/icons/icon-add-file.png";
import { Dialog } from "@progress/kendo-react-dialogs";
import CanvasDraw from "@win11react/react-canvas-draw";
import { useHistory } from "react-router-dom";
import ModalRequest from "../../pures/modal-request/modal-requst-pure";
import DialogPdf from "../../pures/signature-request-detail/dialog-pdf";
import { getStampTimeAndTimezone } from '../../../utils';
import { b64toBlob } from './../../../validators';

let imageWidth = 300;

function setTextInCanvas(x, y, text) {
  try {
    let sourceCanvas = document.getElementsByTagName("canvas")[1];
    let ctx = sourceCanvas.getContext("2d");
    ctx.font = "bold 25px Arial";
    ctx.textAlign = "center";
    ctx.fillText(text, sourceCanvas.width / 2, y);
  } catch (error) { }
}

function drawLine(x, y) {
  try {
    let sourceCanvas = document.getElementsByTagName("canvas")[1];
    let ctx = sourceCanvas.getContext("2d");
    // set line stroke and line width
    ctx.strokeStyle = 'black';
    ctx.lineWidth = 5;

    // draw a red line
    ctx.beginPath();
    ctx.moveTo(sourceCanvas.width * .2, y);
    ctx.lineTo(sourceCanvas.width * .8, y);
    ctx.stroke();
  } catch (error) { }
}

function drawRectangle() {
  try {
    let sourceCanvas = document.getElementsByTagName("canvas")[1]
    let ctx = sourceCanvas.getContext("2d");
    ctx.lineWidth = 5;

    ctx.beginPath();
    ctx.rect(sourceCanvas.width * .1, sourceCanvas.height * .1, sourceCanvas.width * .8, sourceCanvas.height * .8);
    ctx.stroke();
  } catch (error) { }

}

const saveImage = () => {
  let sourceCanvas = document.getElementsByTagName("canvas")[1];
  let destinationCanvas = document.createElement("canvas");
  destinationCanvas.height = sourceCanvas.height;
  destinationCanvas.width = sourceCanvas.width;
  let destinationContext = destinationCanvas.getContext("2d");
  destinationContext.drawImage(sourceCanvas, 0, 0);
  destinationContext.globalCompositeOperation = "destination-over";
  destinationContext.fillStyle = "#4484a500";
  destinationContext.fillRect(
    0,
    0,
    destinationCanvas.width,
    destinationCanvas.height
  );
  let image = destinationCanvas.toDataURL("image/png");
  imageWidth = destinationCanvas.width;
  return image;
};

const RectAddSignature = ({
  title,
  signature,
  setSignature,
  tokenUserNames,
  tokenUserLastnames,
  isUserDocSuppService,
  onErrorTimeStamp
}) => {
  const pad = useRef(null);
  const [emptyImg, setemptyImg] = useState(null);
  const [visibleSignatureAutograph, setVisibleSignatureAutograph] =
    useState(false);
  const toggleSignatureAutograph = () => {
    if (isUserDocSuppService)
      setVisibleSignatureAutograph(!visibleSignatureAutograph);
  };

  useEffect(() => {
    if (visibleSignatureAutograph) {
      setTimeout(() => {
        // setTextInCanvas(100, 255, tokenUserNames);
        // setTextInCanvas(100, 275, tokenUserLastnames);
        // setTextInCanvas(100, 265, `${tokenUserNames} ${tokenUserLastnames}`);
        if (title === 'Firma 2') setTextInCanvas(100, 265, `${tokenUserNames} ${tokenUserLastnames}`);
        // if (title === 'Firma 2') setTextInCanvas(100, 295, `${getStampTimeAndTimezone()}`);
        if (title === 'Firma 3') drawLine(100, 265);
        if (title === 'Firma 4') drawRectangle(100, 265);
        if (title === 'Firma 5') setTextInCanvas(100, 265, `Firma`);

        setemptyImg(saveImage());
      }, 100);
    }
  }, [visibleSignatureAutograph]);

  return (
    <React.Fragment>
      <div>
        <p
          className={`p-sub ${!isUserDocSuppService && "rec-is-user-doc-supp-service"
            } `}
        >
          {title}
        </p>
        <div
          className={`rec ${!isUserDocSuppService && "rec-is-user-doc-supp-service"
            } `}
          onClick={toggleSignatureAutograph}
        >
          <img
            src={signature ? signature : PlusBlue}
            style={{ maxWidth: "100%" }}
          />
        </div>
      </div>
      {visibleSignatureAutograph && (
        <Dialog
          className="modal-form"
          title={"Captura tu firma autógrafa"}
          onClose={toggleSignatureAutograph}
        >
          <p className="calligraphic-grey-text">
            {
              "Por favor genera tu firma autógrafa, busca que sea bajo las condiciones más parecidas a los que tuviste cuando firmaste el documento en revisión, mismo medio de ejecución."
            }
          </p>
          <div className={"canvas-draw"}>
            <CanvasDraw
              ref={pad}
              loadTimeOffset={0}
              lazyRadius={2}
              brushRadius={2}
              brushColor={"#000"}
              catenaryColor={"#0a0302"}
              gridColor={"rgba(150,150,150,0.17)"}
              hideGrid={true}
              canvasWidth={"95%"}
              canvasHeight={300}
              disabled={false}
              immediateLoading={true}
              hideInterface={false}
            />
          </div>
          <div className="btn-conttainer">
            <button
              className="button-download-credential-cancel"
              onClick={toggleSignatureAutograph}
            >
              {"Cancelar"}
            </button>
            <button
              className="button-download-credential-cancel"
              onClick={() => {
                pad.current.clear();
                // setTextInCanvas(100, 255, tokenUserNames);
                // setTextInCanvas(100, 275, tokenUserLastnames);
                // setTextInCanvas(100, 265, `${tokenUserNames} ${tokenUserLastnames}`);
                if (title === 'Firma 2') setTextInCanvas(100, 265, `${tokenUserNames} ${tokenUserLastnames}`);
                // if (title === 'Firma 2') setTextInCanvas(100, 295, `${getStampTimeAndTimezone()}`);
                if (title === 'Firma 3') drawLine(100, 265);
                if (title === 'Firma 4') drawRectangle(100, 265);
                if (title === 'Firma 5') setTextInCanvas(100, 265, `Firma`);
                setSignature(null);
              }}
            >
              {"Limpiar"}
            </button>
            <button
              className="button-download-credential"
              onClick={() => {
                let newImg = saveImage();
                if (emptyImg !== newImg) {
                  setTimeout(async () => {
                    const stampTime = await getStampTimeAndTimezone()
                    if (stampTime === false) {
                      onErrorTimeStamp()
                      return false
                    }
                    // let currentDate = moment().format("YYYY-MM-DD") + " " + moment().format("HH:mm:ss");
                    // setTextInCanvas(100, 295, currentDate);
                    // setTextInCanvas(100, 295, `${getStampTimeAndTimezone()}`);
                    if (title === 'Firma 2') setTextInCanvas(100, 295, `${stampTime}`);
                    setTimeout(() => {
                      newImg = saveImage();
                      setSignature(newImg);
                      toggleSignatureAutograph();
                    }, 0);
                  }, 0);
                }
              }}
            >
              {"Capturar Firma"}
            </button>
          </div>
        </Dialog>
      )}
    </React.Fragment>
  );
};

const CalligraphicExercisesReportDetailRequestView = (props) => {
  const {
    // token,
    requestId,
    tokenUserNames,
    tokenUserLastnames,
    // requestSignatureReplicationService,
    file,
    isUserDocSuppService,
    isInvolved,
    onErrorTimeStamp
  } = props;
  const history = useHistory();
  const [signature1, setSignature1] = useState(null);
  const [signature2, setSignature2] = useState(null);
  const [signature3, setSignature3] = useState(null);
  const [signature4, setSignature4] = useState(null);
  const [signature5, setSignature5] = useState(null);
  // const [signature6, setSignature6] = useState(null);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [currentSystem, setCurrentSystem] = useState("");
  const [blobUrl, setBlobUrl] = useState('')
  const [blob, setBlob] = useState('')
  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  useEffect(() => {
    const blob = b64toBlob(file, 'application/pdf')
    if (file !== '' || file !== null) {
      setBlobUrl(URL.createObjectURL(blob))
      setBlob(blob)
    }
  }, [file])

  const toggleDialog = () => {
    setVisible(!visible);
  };

  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");

  function isTouchScreendevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }

  if (isTouchScreendevice()) {
    isMobile = true;
  }

  const saveFile = async (formData, name, file) =>
    await fetch(file)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], `${name}.png`);
        formData.append(name, file);
      });

  const onSubmit = async () => {
    if (
      signature1 &&
      signature2 &&
      signature3 &&
      signature4 &&
      signature5
    ) {
      let requestDocumentData = new FormData();
      requestDocumentData.append("requestId", requestId);
      requestDocumentData.append("imageWidth", imageWidth);
      await saveFile(requestDocumentData, "signature1", signature1);
      await saveFile(requestDocumentData, "signature2", signature2);
      await saveFile(requestDocumentData, "signature3", signature3);
      await saveFile(requestDocumentData, "signature4", signature4);
      await saveFile(requestDocumentData, "signature5", signature5);
      // await saveFile(requestDocumentData, "signature6", signature6);

      await props.onSubmitReplicationReport(requestDocumentData);
    }
  };

  const resend = async () => {
    if (isLoading) return;

    let requestDocumentData = new FormData();
    requestDocumentData.append("requestId", requestId);
    await props.onSendReport(requestDocumentData);
  };

  let aciveSuccess =
    signature1 &&
    signature2 &&
    signature3 &&
    signature4 &&
    signature5
  // signature6;

  return (
    <React.Fragment>
      {visible && (
        <ModalRequest
          isModal
          toggleDialog={toggleDialog}
          error={error}
          success={success}
          isLoading={isLoading}
        />
      )}
      <div className="calligraphicExercisesReportDetailRequestView-wrapper">
        {props.loading ? (
          <SimpleLoading />
        ) : (
          <div className="calligraphicExercisesReportDetailRequestView-globalContainerStyles">
            <div className="table-card-queriesValidations">
              <div className="table-queriesValidations">
                <h3 className="table-title-queriesValidations">
                  {props.requestTypeId === 2
                    ? "Validación de documentos"
                    : "Ejercicios caligráficos"}
                </h3>
              </div>

              {file ? (
                <React.Fragment>
                  {isMobile ? (
                    <div className="pdf-btn">
                      <DialogPdf blobUrl={blobUrl} />
                    </div>
                  ) : (
                    <div style={{ width: "90%", margin: "auto" }}>
                      <iframe
                        name="document_pdf"
                        id="myiframe"
                        width="100%"
                        height="600px"
                        src={`${blobUrl}#view=fitH`}
                        className="canvas_container_pdf_render"
                      />
                    </div>
                  )}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <p style={{ marginBottom: 0, padding: "3px 40px" }}>
                    {isUserDocSuppService
                      ? `Por favor genera tu firma autógrafa, busca que sea bajo las condiciones más parecidas a los que tuviste cuando firmaste el documento en revisión, mismo medio de ejecución. Da clic en cada recuadro para abrir el área de firma.`
                      : `Este reporte requiere que el usuario haya establecido su firma base y  proporcionado su INE. Si no lo has hecho, por favor ve a tu perfil de usuario y da clic en la opción Firma autógrafa para hacerlo. Gracias.`}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      margin: "auto",
                      justifyContent: "space-evenly",
                      maxWidth: 1200,
                    }}
                  >
                    <RectAddSignature
                      isUserDocSuppService={isUserDocSuppService}
                      tokenUserNames={tokenUserNames}
                      tokenUserLastnames={tokenUserLastnames}
                      signature={signature1}
                      setSignature={setSignature1}
                      title="Firma 1"
                      onErrorTimeStamp={onErrorTimeStamp}
                    />
                    <RectAddSignature
                      isUserDocSuppService={isUserDocSuppService}
                      tokenUserNames={tokenUserNames}
                      tokenUserLastnames={tokenUserLastnames}
                      signature={signature2}
                      setSignature={setSignature2}
                      title="Firma 2"
                      onErrorTimeStamp={onErrorTimeStamp}
                    />
                    <RectAddSignature
                      isUserDocSuppService={isUserDocSuppService}
                      tokenUserNames={tokenUserNames}
                      tokenUserLastnames={tokenUserLastnames}
                      signature={signature3}
                      setSignature={setSignature3}
                      title="Firma 3"
                      onErrorTimeStamp={onErrorTimeStamp}
                    />
                    <RectAddSignature
                      isUserDocSuppService={isUserDocSuppService}
                      tokenUserNames={tokenUserNames}
                      tokenUserLastnames={tokenUserLastnames}
                      signature={signature4}
                      setSignature={setSignature4}
                      title="Firma 4"
                      onErrorTimeStamp={onErrorTimeStamp}
                    />
                    <RectAddSignature
                      isUserDocSuppService={isUserDocSuppService}
                      tokenUserNames={tokenUserNames}
                      tokenUserLastnames={tokenUserLastnames}
                      signature={signature5}
                      setSignature={setSignature5}
                      title="Firma 5"
                      onErrorTimeStamp={onErrorTimeStamp}
                    />
                    {/* <RectAddSignature
                      isUserDocSuppService={isUserDocSuppService}
                      tokenUserNames={tokenUserNames}
                      tokenUserLastnames={tokenUserLastnames}
                      signature={signature6}
                      setSignature={setSignature6}
                      title="Firma 6"
                    /> */}
                  </div>
                </React.Fragment>
              )}

              <div className="btn-contianer">
                <button
                  onClick={() => history.goBack()}
                  className="back-style-queriesValidations"
                >
                  {file ? "Regresar" : "Cancelar"}
                </button>

                {isUserDocSuppService && (
                  <React.Fragment>
                    {file ? (
                      <button
                        // type='submit'
                        onClick={resend}
                        className="back-style-queriesValidations"
                      >
                        {"Reenviar correo"}
                      </button>
                    ) : (
                      <React.Fragment>
                        {isInvolved && (
                          <button
                            // type='submit'
                            onClick={onSubmit}
                            className={`foward-style-queriesValidations ${!aciveSuccess &&
                              "back-style-queriesValidations-disable"
                              }`}
                          >
                            {"Generar reporte"}
                          </button>
                        )}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
              </div>
              <PromotionalFooterPure />
            </div>
          </div>
        )}
      </div>

      <DialogSystemGLPure
        {...props}
        toggleLoadingRequesting={props.toggleLoadingRequesting}
        toggleCompletedRequesting={props.toggleCompletedRequesting}
        toggleErrorRequesting={props.toggleErrorRequesting}
      />
    </React.Fragment>
  );
};

export { CalligraphicExercisesReportDetailRequestView as default };
